<template>
  <div class>
    <v-toolbar text class="transparent" elevation="0" height="auto">
      <h4>All Organizations</h4>
      <div
        class="d-flex sortBySection"
        v-if="orgList.children && orgList.children.length"
      >
        <p class="white--text">Sort by:</p>
        <v-btn
          :class="{ active: selectedSort === 'name' }"
          text
          small
          class="white--text"
          :ripple="false"
          @click="handleSortSelection('name')"
          data-test-id="configuration-sidebar__sort-by-label__a-to-z-btn"
        >
          A-Z
          <v-icon v-if="selectedSort === 'name'" right size="12" class="ml-0">{{
            sortOrder === 'ASC' ? 'arrow_downward' : 'arrow_upward'
          }}</v-icon>
        </v-btn>
        <v-btn
          :class="{ active: selectedSort === 'count' }"
          text
          class="white--text ml-2"
          small
          :ripple="false"
          @click="handleSortSelection('count')"
          data-test-id="configuration-sidebar__sort-by-label__account-count-btn"
        >
          Account count
          <v-icon
            v-if="selectedSort === 'count'"
            right
            size="12"
            class="ml-0"
            >{{
              sortOrder === 'ASC' ? 'arrow_upward' : 'arrow_downward'
            }}</v-icon
          >
        </v-btn>
      </div>
      <v-divider></v-divider>
    </v-toolbar>

    <div class="companyNameList my-3">
      <TableLoader v-if="loading" />
      <v-treeview
        v-else
        ref="treeview"
        dense
        :items="orgListTree"
        open-all
        :value="[activeOrg]"
        :active-class="'v-treeview-node--active'"
        :class="{
          'selected-item': orgList.orgId === activeOrg
        }"
        :item-key="'orgId'"
        :item-text="'label'"
        height="'20px'"
      >
        <span
          @click="updateSelectedOrganisation(item, active)"
          slot="label"
          slot-scope="{ item, active }"
          :class="{ 'selected-node': item.orgId === activeOrg }"
          :data-test-id="`configuration-sidebar__org-list-items__${item.orgId}`"
        >
          {{ item.label }}
        </span>
      </v-treeview>
    </div>
  </div>
</template>

<script>
import EventBus from '@/EventBus';
import { mapMutations } from 'vuex';
import TableLoader from '@/components/Common/TableLoader.vue';
export default {
  name: 'OrganisationList',
  data() {
    return {
      loading: true,

      orgList: [],
      orgListTree: [],
      selectedSort: 'name',
      sortOrder: 'ASC',
      orgTreeList: []
    };
  },
  computed: {
    activeOrg: {
      get() {
        return this.currentlySelectedOrgId;
      },
      set(orgId) {
        this.setSelectedOrg(orgId);
      }
    }
  },
  components: {
    TableLoader
  },
  methods: {
    getActiveNodes() {
      return [this.activeOrg];
    },
    ...mapMutations(['setSelectedOrg']),
    async updateSelectedOrganisation(item) {
      //check whether it's own org or child org
      this.activeOrg = item.orgId;
      await this.onOrgChange();
    },
    ...mapMutations(['setAllOrgFlattened']),
    handleSortSelection(sortBy) {
      if (this.selectedSort !== sortBy) {
        this.sortOrder = sortBy === 'name' ? 'ASC' : 'DESC';
      } else {
        this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
      }
      this.selectedSort = sortBy;
      this.getUserOrgs();
    },
    async getUserOrgs() {
      this.loading = true;

      try {
        this.loading = false;
        let orgList = await this.getOrgListData(
          this.selectedSort,
          this.sortOrder
        );

        if (!orgList.success) {
          // ERROR_LOADING_DATA
          this.snackbar('error', this.$message.ERROR_LOADING_DATA);
          return;
        }
        if (orgList.body.length === 0) {
          this.snackbar('error', this.$message.NO_ORG);
          return;
        }
        this.orgList = orgList.body[0].response;
        this.orgListTree = this.createTreeView(orgList.body[0].response);
      } catch (e) {
        this.loading = false;
        // ERROR_LOADING_DATA
        console.log(e);
        this.snackbar('error', this.$message.ERROR_LOADING_DATA);
      }
    },
    createTreeView(orgList) {
      let formattedTree = this.getOrgChildren(orgList);
      return [formattedTree];
    },
    getOrgChildren(orgList) {
      orgList.label = `${orgList.organisationName} (${orgList.activeCount})`;
      if (orgList.children) {
        for (var i = 0; i < orgList.children.length; i++) {
          this.getOrgChildren(orgList.children[i]);
        }
      }
      return orgList;
    }
  },
  mounted() {
    EventBus.$on('refreshOrgList', () => {
      this.getUserOrgs();
    });
    this.getUserOrgs();
  }
};
</script>

<style>
.v-treeview-node__label {
  font-size: 15px;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  white-space: normal;
}
.v-treeview--dense .v-treeview-node__root {
  min-height: 30px;
}

.v-treeview-node--active .v-treeview-node__label {
  color: #fff;
}

.v-treeview-node__label span {
  color: #fff;
}
.selected-node {
  color: #1b2342 !important;
}
</style>
